import axios from '../axios'
import Vue from 'vue'
//
export const getStuUserInfo = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/userinfo',
    method: 'get',
    params: data
  })
}

//
export const getStuUserLiveStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/userlivestat',
    method: 'get',
    params: data
  })
}

export const getStuUserCheckStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/usercheckstat',
    method: 'get',
    params: data
  })
}

export const getStuUserLiveInfoStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/userliveinfostat',
    method: 'get',
    params: data
  })
}

export const getStuUserLiveInfoSearchStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/userliveinfosearchstat',
    method: 'get',
    params: data
  })
}

export const getStuUserCourseStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/usercoursestat',
    method: 'get',
    params: data
  })
}

export const getTeaCourseLiveStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/teachercourselivestat',
    method: 'get',
    params: data
  })
}

export const getTeaLiveInfoStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/teacherliveinfostat',
    method: 'get',
    params: data
  })
}

export const getTeaLiveInfoSearchStat = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/userstat/teacherliveinfosearchstat',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/userInfo.js